export default "__VITE_ASSET__BuZp0AcW__"